import {withFormik} from "formik";

import FunctionButton from "../../../../../utilities/Buttons/FunctionButton";
import Divider from "../../../../../utilities/Divider/Divider";
import {UI_PERMISSION_TYPE} from "../../../../adminForms/Ba3aSettings/tabs/PositionsSettings/useRoutePermissions";

import DiscountsPart from "./parts/DiscountsPart";
import MainServicesAndDiscountsTable from "./parts/MainServicesAndDiscountsTable";
import ServicePart from "./parts/ServicePart";
export const DISCOUNT_RADIOS = {COF_NUMBER: "cofNumber", BRAND: "brand"};

export const ServicesAndDiscountsBase = ({setModalOpen, onSave, setIsSaved, kpReadOnly = false}) => {
  return (
    <div className="pt fcCol w100 aistr fGrow">
      <DiscountsPart setIsSaved={setIsSaved} kpReadOnly={kpReadOnly} />
      <Divider margin="5px" />
      <ServicePart setIsSaved={setIsSaved} kpReadOnly={kpReadOnly} />
      <Divider margin="5px" />
      <MainServicesAndDiscountsTable />
      <FunctionButton
        name={kpReadOnly ? "Exit" : "Save and close"}
        onClick={() => {
          onSave();
          setModalOpen(false);
        }}
        className="asfe"
        uiPermissionType={UI_PERMISSION_TYPE.READABLE}
      />
    </div>
  );
};

const ServicesAndDiscounts = withFormik({
  mapPropsToValues: () => ({sum: "", ammount: ""}),
  enableReinitialize: true,
})(ServicesAndDiscountsBase);

export default ServicesAndDiscounts;
